import { SVGProps } from 'react';

export const ErrorIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='64'
    height='63'
    viewBox='0 0 64 63'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <g filter='url(#filter0_di_1149_178892)'>
      <path
        d='M23.9998 5.85352C28.1317 2.69359 33.8683 2.69359 38.0002 5.85352C39.5969 7.07466 41.4853 7.85686 43.4778 8.12245C48.6339 8.80971 52.6903 12.8661 53.3775 18.0222C53.6431 20.0147 54.4253 21.9031 55.6465 23.4998C58.8064 27.6317 58.8064 33.3683 55.6465 37.5002C54.4253 39.0969 53.6431 40.9853 53.3775 42.9778C52.6903 48.1339 48.6339 52.1903 43.4778 52.8775C41.4853 53.1431 39.5969 53.9253 38.0002 55.1465C33.8683 58.3064 28.1317 58.3064 23.9998 55.1465C22.4031 53.9253 20.5147 53.1431 18.5222 52.8775C13.3661 52.1903 9.30971 48.1339 8.62245 42.9778C8.35686 40.9853 7.57466 39.0969 6.35352 37.5002C3.19359 33.3683 3.19359 27.6317 6.35352 23.4998C7.57466 21.9031 8.35686 20.0147 8.62245 18.0222C9.30971 12.8661 13.3661 8.80971 18.5222 8.12245C20.5147 7.85686 22.4031 7.07466 23.9998 5.85352Z'
        fill='#D82828'
      />
      <path
        d='M24.3036 6.25069C28.2562 3.22787 33.7438 3.22787 37.6964 6.25069C39.3624 7.52481 41.3328 8.34096 43.4118 8.61807C48.3441 9.27551 52.2245 13.1559 52.8819 18.0882C53.159 20.1672 53.9752 22.1376 55.2493 23.8036C58.2721 27.7562 58.2721 33.2438 55.2493 37.1964C53.9752 38.8624 53.159 40.8328 52.8819 42.9118C52.2245 47.8441 48.3441 51.7245 43.4118 52.3819C41.3328 52.659 39.3624 53.4752 37.6964 54.7493C33.7438 57.7721 28.2562 57.7721 24.3036 54.7493C22.6376 53.4752 20.6672 52.659 18.5882 52.3819C13.6559 51.7245 9.77551 47.8441 9.11807 42.9118C8.84096 40.8328 8.02481 38.8624 6.75069 37.1964C3.72787 33.2438 3.72787 27.7562 6.75069 23.8036C8.02481 22.1376 8.84096 20.1672 9.11807 18.0882C9.77551 13.1559 13.6559 9.27551 18.5882 8.61807C20.6672 8.34096 22.6376 7.52481 24.3036 6.25069Z'
        stroke='url(#paint0_linear_1149_178892)'
      />
    </g>
    <path
      d='M23 39L39 23M23 23L39 39'
      stroke='white'
      strokeWidth='4'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <defs>
      <filter
        id='filter0_di_1149_178892'
        x='0.983572'
        y='0.483398'
        width='62.0329'
        height='62.0332'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='1' dy='1' />
        <feGaussianBlur stdDeviation='2' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.314984 0 0 0 0 0.0877507 0 0 0 0 0.0877507 0 0 0 0.7 0'
        />
        <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_1149_178892' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect1_dropShadow_1149_178892'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='1' dy='3' />
        <feGaussianBlur stdDeviation='2.5' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.941671 0 0 0 0 0.686454 0 0 0 0 0.686454 0 0 0 1 0'
        />
        <feBlend mode='normal' in2='shape' result='effect2_innerShadow_1149_178892' />
      </filter>
      <linearGradient
        id='paint0_linear_1149_178892'
        x1='19.6585'
        y1='0.865854'
        x2='40.5122'
        y2='59.0366'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#D82828' />
        <stop offset='1' stopColor='#9D1F1F' />
      </linearGradient>
    </defs>
  </svg>
);
